import React from "react"
import Dp from "../images/dp.png"

const About = () => {
    return (
        <div id="about">
            <h1>About me</h1>
            <div className="info">
                <div className="img">
                    <img src={Dp} alt="dp"/>
                </div>
                <div className="about">
                    <div><h2><span>&#xb7;</span>Learner&nbsp;&nbsp;<span>&#xb7;</span>Web developer&nbsp;&nbsp;<span>&#xb7;</span>Awesome dude</h2></div>
                    <p>
                        Hello, I'm Benedict Steven. I'm a front-end developer 
                        who can develop unique websites. I am a passionate self-taught developer who fell in
                        love with programming and creating websites one year ago. Since then, I've been experimenting, 
                        creating, and learning everything that I can about web development.
                        Nothing compares to the feeling of creating something from nothing.
                         I am currently available for any small freelance projects, as well as full 
                         time positions as a front-end (or potentially backend) developer. 
                         Please contact me using the form below or using the social media links below.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default About;